import { render, staticRenderFns } from "./QuestionNotFound.vue?vue&type=template&id=2ca988f0&"
import script from "./QuestionNotFound.vue?vue&type=script&lang=js&"
export * from "./QuestionNotFound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports